import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Icon } from 'src/components'
import { mergeProps } from 'src/util'
import Button from '../Button'
import styles from './ButtonIcon.scss'

/**
 * The [Button](#Button) component with an icon.
 */
const ButtonIcon = ({
  icon,
  color,
  loadingColor,
  iconRight,
  children,
  iconClassName,
  disabled,
  loading,
  ...domProps
}) => (
  <Button
    {...mergeProps()(
      {
        disabled: disabled || loading,
        color: loading ? loadingColor : color,
        className: [styles.button, { [styles.alone]: !children }],
      },
      domProps
    )}
  >
    {iconRight && children}
    <Icon
      loading={loading}
      className={classnames(styles.icon, iconClassName, { [styles.right]: iconRight })}
      icon={icon}
      fixedWidth
    />
    {!iconRight && children}
  </Button>
)

ButtonIcon.defaultProps = {
  ...Button.defaultProps,
  loadingColor: 'info',
  iconRight: false,
}

ButtonIcon.propTypes = {
  ...Button.propTypes,
  /**
   * Name of the FontAwesome icon.
   */
  icon: PropTypes.elementType,
  /**
   * The color of the button.
   */
  color: PropTypes.string,
  /**
   * The loading color of the button.
   */
  loadingColor: PropTypes.string,
  /**
   * Whether or not the icon should be displayed at the right of the button content.
   */
  iconRight: PropTypes.bool,
  /**
   * The content of the button.
   */
  children: PropTypes.node,
  /**
   * Whether the button should be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Whether the button should disable itself and display a loader instead of the icon.
   */
  loading: PropTypes.bool,
}

export default ButtonIcon
